import { JSONSchema7 } from 'json-schema';
import * as yup from 'yup';
import ControlState from '../../Shared/controlState';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';

export default (
  control: ControlState
): {
  [key: string]: yup.AnySchema;
} => {
  const properties = control.schema?.properties as JSONSchema7Properties;
  const labelSchema = properties['label'] as JSONSchema7;
  const requiredSchema = properties['required'] as JSONSchema7;
  const maximumSchema = properties['maximum'] as JSONSchema7;

  let controlYupSchema = yup.string();

  if (!control.visible) {
    return {
      [control.id]: controlYupSchema
    };
  }

  if (requiredSchema && requiredSchema.default) {
    controlYupSchema = controlYupSchema.required(
      `${labelSchema.default} is required`
    );
  }

  if (maximumSchema) {
    const max = parseInt(maximumSchema.default as string);
    controlYupSchema = controlYupSchema.max(
      max,
      `${labelSchema.default} must be less or equal to ${max}`
    );
  }

  return {
    [control.id]: controlYupSchema
  };
};
